import React, { useState } from 'react';

type Variant = 'light' | 'onWhiteChip';

interface ServetWordmarkProps {
  variant?: Variant;
  className?: string;
}

/**
 * SerVet Digital lockup. Renders the logo image from /public; if the asset is
 * missing (e.g. not yet pushed to the branch) it falls back to a styled text
 * wordmark so the page never shows a broken image — the real logo swaps in
 * automatically once the file lands at /servet-digital-logo.png.
 *
 * `light`        → small mark for the nav ("from …") on the light app surface.
 * `onWhiteChip`  → larger mark for the footer's white "A PRODUCT OF" chip.
 */
export function ServetWordmark({ variant = 'light', className = '' }: ServetWordmarkProps) {
  const [imgOk, setImgOk] = useState(true);
  const height = variant === 'onWhiteChip' ? 20 : 16;

  if (imgOk) {
    return (
      <img
        src="/servet-digital-logo.png"
        alt="SerVet Digital"
        style={{ height, width: 'auto', display: 'block' }}
        className={className}
        onError={() => setImgOk(false)}
      />
    );
  }

  return (
    <span
      className={`font-mono font-semibold tracking-tight whitespace-nowrap ${
        variant === 'onWhiteChip' ? 'text-bw-sidebar text-sm' : 'text-bw-muted text-[11px]'
      } ${className}`}
    >
      SerVet&nbsp;Digital
    </span>
  );
}
